import { IPaginationResult } from './Equipment.model';

// Simply
// eslint-disable-next-line @typescript-eslint/ban-types
abstract class DataConverter<From, To extends Partial<Base>, Base = object> {
  private defaultSortFn: SortFn<To>;

  abstract fromApiModel(model: From): To;

  /** Auto Trait impl */
  fromArrayApiModel(model: From[]): To[] {
    const result = model.map(this.fromApiModel);
    return result;
  }

  // Can add sorted variants
  fromSortedArrayApiModel(
    model: From[],
    sortFn: SortFn<To> = this.defaultSortFn,
  ): To[] {
    const _result = this.fromArrayApiModel(model);
    const result = _result.sort(sortFn);
    return result;
  }
  // Paginated variants

  fromArrayPaginatedApiModel(
    model: IPaginationResult<From>,
  ): IPaginationResult<To> {
    const results = this.fromArrayApiModel(model.results);
    return { ...model, results };
  }

  // Sorted paginated variants
  fromSortedArrayPaginatedApiModel(
    model: IPaginationResult<From>,
  ): IPaginationResult<To> {
    const results = this.fromSortedArrayApiModel(model.results);
    return { ...model, results };
  }
}

export default DataConverter;

export type SortFn<T> = Parameters<T[]['sort']>[0];
